import moment from "moment";
import _ from "lodash";
import { TABLE_COLUMNS } from "./constants";

export function buildFilterOptions({ orders }) {
  const mappedOrders = !orders
    ? []
    : orders.orders.map((order) => ({
        ...order,
        price: `$${order.amount.toFixed(2)}`,
        createdAt: moment(order.createdAt).format("MMM D, YYYY hh:mm A"),
        address: `${order.destination.street1}, ${order.destination.city}, ${order.destination.state} ${order.destination.postalCode}`,
        buyer: order.destination.name,
        seller: order.seller.name,
        name: order.product.name
      }));

  return [
    {
      key: "name",
      label: "Product Name",
      type: "menu",
      options: _.uniqBy(mappedOrders, "name").map((o) => ({
        key: o.product.name,
        label: o.product.name
      })),
      filter: true
    },
    {
      key: "buyer",
      label: "Customer Name",
      type: "menu",
      options: _.uniqBy(mappedOrders, "buyer").map((o) => ({
        key: o.buyer,
        label: o.buyer
      })),
      filter: true
    },
    {
      key: "email",
      label: "Customer Email",
      type: "menu",
      options: _.uniqBy(mappedOrders, "email").map((o) => ({
        key: o.email,
        label: o.email
      })),
      filter: true
    },
    {
      key: "id",
      label: "Order Number",
      type: "menu",
      options: _.uniqBy(mappedOrders, "id").map((o) => ({
        key: o.id,
        label: o.id
      })),
      filter: true
    },
    {
      key: "status",
      label: "Order Status",
      type: "menu",
      options: [
        {
          key: "pending",
          label: "Pending"
        },
        {
          key: "processing",
          label: "Processing"
        },
        {
          key: "fulfilled",
          label: "Fulfilled"
        }
      ]
    },
    {
      key: "createdAt",
      label: "Order Date",
      type: "dateRange"
    }
  ];
}

export function buildGetOrdersVariables({ sort, filters, cursor }) {
  const variables = {
    id: {},
    name: {},
    price: {},
    createdAt: {},
    quantity: {},
    status: {},
    email: {},
    address: {},
    buyer: {},
    seller: {},
    ...buildQuerySortDirection({ sort, cursor })
  };

  const filterKeys = Object.keys(filters);

  filterKeys.forEach((key) => {
    if (key === "createdAt") {
      variables[key] = {
        ...variables[key],
        greaterThan: new Date(filters[key][0]).toUTCString(),
        lessThan: new Date(filters[key][1]).toUTCString()
      };
    } else {
      variables[key] = {
        ...variables[key],
        equals: filters[key].label
      };
    }
  });

  return {
    variables: {
      ...variables,
      ...(cursor && { cursor: cursor.id })
      /*limit: ORDER_QUERY_LIMIT*/
    }
  };
}

export function buildQuerySortDirection({ sort, cursor }) {
  const currentSortIsDesc = sort.direction === "desc";
  const fieldIsCreatedAt = sort.field === "createdAt";
  const useDescending = fieldIsCreatedAt
    ? !currentSortIsDesc
    : currentSortIsDesc;

  return {
    [sort.field]: {
      orderBy: useDescending ? "Descending" : "Ascending",
      ...(cursor && {
        cursor:
          sort.field === "createdAt"
            ? new Date(cursor[sort.field]).toUTCString()
            : cursor[sort.field]
      })
    }
  };
}

export function getColumnWidth({ columnWidths, index, width }) {
  const statusButtonWidth = 115;
  const isStatusButtonColumn = index === 5;

  if (isStatusButtonColumn) {
    return statusButtonWidth;
  }

  const adjustedWidth = width - statusButtonWidth;

  return columnWidths[index] || adjustedWidth / 9;
}

export const onColumnResizeHof = ({ columnWidths, setColumnWidths }) => ({
  column,
  width
}) => {
  if (!columnWidths.length) {
    setColumnWidths(new Array(10).fill(null));
  }

  const index = TABLE_COLUMNS.findIndex((c) => c.key === column.key);
  const newWidths = columnWidths;
  newWidths[index] = width;

  setColumnWidths(newWidths);
};
